// extracted by css-extract-rspack-plugin
export default {"modal":"uk2lAOzJhMDqTaXZ"};